import { parsePhoneNumber } from 'libphonenumber-js';

export const getPhoneCountryInfo = (phoneNumber: string) => {
  try {
    // Default to US if no phone number provided
    if (!phoneNumber) return { code: '1', name: 'US' };

    // Parse the phone number
    const parsedNumber = parsePhoneNumber(phoneNumber);

    // Get the country code (without '+' prefix)
    const code = parsedNumber.countryCallingCode;

    // Get the country name (2-letter ISO code)
    const name = parsedNumber.country || 'international';

    return { code, name };
  } catch (error) {
    // Return default values if parsing fails
    return { code: '1', name: 'US' };
  }
};
